/* Trucks on the order — each truck once, in cart attributes (the order's
   "Additional details"), never on the lines. Contract: Cart Catalyst
   docs/storefront.md, "Trucks on the order".

     Truck 1                2019 Chevy / GMC Silverado 2500 HD · Pickup · L5P 6.6L Duramax · VIN … checked · 4 Wheel Drive
     Truck 1 modifications  DPF/EGR deleted
     _cc_trucks             the same, as JSON, so a later add can merge into it
                            (the app's order webhook moves it into the order's
                            Trucks metafield and removes it from the order)

   Why: every line property prints beside its part on every packing slip and
   Shippo label, and a kit's properties print beside every one of its parts.
   The per-product "Field — Product" attributes this replaces were never
   removed, so orders listed trucks from earlier carts.

   A wholesaler's cart holds several trucks. While it holds one, lines say
   nothing about it; once it holds two, every line carries one visible
   property, "Truck: N". The lines already in the cart get "Truck: 1" when the
   second truck arrives, and lose it again when the cart drops back to one.

   window.tdtTrucks.fields          property names that are truck facts
   window.tdtTrucks.prepare(record) -> Promise<{ number, multi }>, before an add
   window.tdtTrucks.commit(record, number) -> Promise, after the add succeeded
   window.tdtTrucks.reconcile()     -> Promise; also runs on load and cart:updated */
(function () {
  var FIELDS = ['Vehicle', 'Modifications', 'Drive Type', 'Rear Axle Type', 'Fuel Tank Type', 'Transfer Case Type', 'Tire Size'];
  var SPEC_ORDER = ['Drive Type', 'Rear Axle Type', 'Fuel Tank Type', 'Transfer Case Type', 'Tire Size'];
  var STATE = '_cc_trucks';
  var POINTER = 'Truck';
  var busy = false;

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  /* "2019 … · L5P 6.6L Duramax · VIN 1GC… checked" -> truck + VIN part */
  function splitVehicle(text) {
    var parts = String(text || '').split(' · ').map(function (p) { return p.trim(); }).filter(Boolean);
    for (var i = 0; i < parts.length; i++) {
      if (/^VIN\b/.test(parts[i])) return { vehicle: parts.slice(0, i).join(' · '), vin: parts.slice(i).join(' · ') };
    }
    return { vehicle: parts.join(' · '), vin: null };
  }
  /* The VIN as typed, checked or not ("VIN %v% checked", "… not verified — …"):
     two different VINs are two trucks even when one failed the format check. */
  function vinCode(vin) {
    var m = /^VIN\s+(\S+)/.exec(vin || '');
    return m ? m[1].toUpperCase() : null;
  }

  /* What one add-to-cart says about its truck, from the form's fields. */
  function recordFrom(fields) {
    var v = splitVehicle(fields.Vehicle);
    var rec = { vehicle: v.vehicle, vin: v.vin, specs: {}, mods: '' };
    Object.keys(fields).forEach(function (k) {
      var val = String(fields[k] || '').trim();
      if (!val || k === 'Vehicle') return;
      if (k === 'Modifications') rec.mods = val;
      else rec.specs[k] = val;
    });
    return rec;
  }
  function empty(rec) {
    return !rec.vehicle && !rec.vin && !rec.mods && !Object.keys(rec.specs).length;
  }

  function line(t) {
    var specs = Object.keys(t.specs || {}).sort(function (a, b) {
      var ia = SPEC_ORDER.indexOf(a), ib = SPEC_ORDER.indexOf(b);
      return ((ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib)) || a.localeCompare(b);
    }).map(function (k) { return t.specs[k]; });
    return [t.vehicle, t.vin].concat(specs).filter(Boolean).join(' · ');
  }

  function trucksOf(cart) {
    try {
      var list = JSON.parse((cart.attributes || {})[STATE] || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  /* Same truck: same vehicle (or one side doesn't say), VINs don't disagree. */
  function findTruck(trucks, rec) {
    var code = vinCode(rec.vin);
    var hits = trucks.filter(function (t) {
      var tc = vinCode(t.vin);
      if (code && tc && code !== tc) return false;
      if (code && tc && code === tc) return true;
      if (rec.vehicle && t.vehicle) return rec.vehicle === t.vehicle;
      return trucks.length === 1;
    });
    return hits[0] || null;
  }

  function pointerOf(item) {
    var p = item.properties || {};
    return p[POINTER] ? String(p[POINTER]) : null;
  }

  /* Rewrite one line's properties, keeping everything else on it. */
  function setPointer(item, number) {
    var props = Object.assign({}, item.properties || {});
    if (number) props[POINTER] = String(number);
    else delete props[POINTER];
    return post('/cart/change.js', { id: item.key, quantity: item.quantity, properties: props });
  }

  /* Point every line at a truck (or at none), one change at a time: each
     change gives the line a new key, so the cart is read again in between. */
  function pointAll(number) {
    var guard = 0;
    function step() {
      return getCart().then(function (cart) {
        /* With a number: the lines not yet pointed. Without: the pointed ones. */
        var item = cart.items.filter(function (i) { return number ? !pointerOf(i) : !!pointerOf(i); })[0];
        if (!item || ++guard > 60) return cart;
        return setPointer(item, number).then(step);
      });
    }
    return step();
  }

  function attributesFor(cart, trucks) {
    var attrs = {};
    var current = cart.attributes || {};
    Object.keys(current).forEach(function (k) {
      /* Our own keys are rewritten below; the old per-product mirror goes. */
      if (k === STATE || /^Truck \d+( modifications)?$/.test(k) || / — /.test(k)) attrs[k] = '';
    });
    trucks.forEach(function (t) {
      attrs['Truck ' + t.number] = line(t);
      attrs['Truck ' + t.number + ' modifications'] = t.mods || '';
    });
    attrs[STATE] = trucks.length ? JSON.stringify(trucks) : '';
    return attrs;
  }
  function writeTrucks(cart, trucks) {
    return post('/cart/update.js', { attributes: attributesFor(cart, trucks) });
  }

  /* Before an add: which truck this is, and whether the cart now holds more
     than one. Lines already in the cart are pointed at truck 1 here, so the
     new line can be added pointing at its own. */
  function prepare(fields) {
    var rec = recordFrom(fields);
    if (empty(rec)) return Promise.resolve({ number: null, multi: false, record: rec });
    busy = true;
    return getCart().then(function (cart) {
      var trucks = trucksOf(cart);
      var found = findTruck(trucks, rec);
      var number = found ? found.number : trucks.reduce(function (m, t) { return Math.max(m, t.number); }, 0) + 1;
      var others = trucks.filter(function (t) { return t.number !== number; });
      var multi = others.length > 0 && cart.item_count > 0;
      if (!multi) return { number: number, multi: false, record: rec };
      /* The cart was single-truck until now: its lines are that truck's. */
      var single = cart.items.some(pointerOf) ? null : (others.length === 1 ? others[0].number : null);
      return (single ? pointAll(single) : Promise.resolve()).then(function () {
        return { number: number, multi: true, record: rec };
      });
    }).catch(function (e) { busy = false; throw e; });
  }

  /* After a successful add: merge the record into its truck and write. */
  function commit(rec, number) {
    if (!number) { busy = false; return Promise.resolve(); }
    return getCart().then(function (cart) {
      var trucks = trucksOf(cart);
      var t = trucks.filter(function (x) { return x.number === number; })[0];
      if (!t) {
        t = { number: number, vehicle: '', vin: null, specs: {}, mods: '' };
        trucks.push(t);
      }
      t.vehicle = t.vehicle || rec.vehicle;
      t.vin = rec.vin || t.vin;
      Object.keys(rec.specs).forEach(function (k) { t.specs[k] = rec.specs[k]; });
      t.mods = rec.mods || t.mods;
      trucks.sort(function (a, b) { return a.number - b.number; });
      return writeTrucks(cart, trucks);
    }).then(function () { busy = false; }, function () { busy = false; });
  }

  /* After anything else changed the cart: drop trucks whose last part went,
     drop the pointers when one truck is left, clear the old mirror. Resolves
     true when it changed the cart (line keys may have changed too). */
  function reconcile() {
    if (busy) return Promise.resolve(false);
    return getCart().then(function (cart) {
      var trucks = trucksOf(cart);
      var attrs = cart.attributes || {};
      /* Non-empty only: if "" leaves the key behind, it must not count again. */
      var stale = Object.keys(attrs).some(function (k) { return / — /.test(k) && attrs[k]; });
      if (!cart.item_count) {
        return trucks.length || stale ? writeTrucks(cart, []) : null;
      }
      var used = {};
      cart.items.forEach(function (i) { var p = pointerOf(i); if (p) used[p] = true; });
      var pointed = Object.keys(used).length > 0;
      var live = pointed ? trucks.filter(function (t) { return used[String(t.number)]; }) : trucks;
      if (pointed && live.length <= 1) {
        /* Back to one truck: lines stop saying which, and it is truck 1. */
        return pointAll(null).then(function (fresh) {
          live.forEach(function (t) { t.number = 1; });
          return writeTrucks(fresh, live);
        });
      }
      if (live.length !== trucks.length || stale) return writeTrucks(cart, live);
      return null;
    }).then(function (wrote) { return !!wrote; }, function () { return false; });
  }

  /* A rewritten line has a new key and maybe a different truck label, so what
     the drawer or the cart page rendered is stale: re-render the drawer, reload
     the page (the next reconcile finds nothing to do, so it reloads once). */
  function reconcileAndRefresh() {
    return reconcile().then(function (changed) {
      if (!changed) return;
      if (document.querySelector('[data-cart-page]')) window.location.reload();
      else if (window.tdtCartDrawer) window.tdtCartDrawer.refresh();
    });
  }

  window.tdtTrucks = { fields: FIELDS, prepare: prepare, commit: commit, reconcile: reconcileAndRefresh };

  document.addEventListener('cart:updated', reconcileAndRefresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcileAndRefresh);
  else reconcileAndRefresh();
})();
